import type { InitialSyncStatus } from '@/lib/initial-sync-context';

/**
 * Blocking splash shown during the FIRST-LOGIN bulk download. Shows
 * "Synchronisation initiale 23 / 47 (Articles…)" so the user
 * understands the wait. Subsequent logins skip this gate and load
 * straight from the persisted cache.
 */
export function InitialSyncSplash({ status }: { status: InitialSyncStatus }) {
  const pct =
    status.total > 0 ? Math.min(100, Math.round((status.completed / status.total) * 100)) : 0;
  const detail =
    status.total > 0
      ? `${status.completed} / ${status.total}${status.currentLabel ? ` — ${status.currentLabel}` : ''}`
      : 'Préparation…';

  return (
    <div
      className="fixed inset-0 z-[9999] flex min-h-screen w-screen items-center justify-center bg-background px-6"
      style={{ background: 'var(--background, #fff)' }}
      role="status"
      aria-live="polite"
    >
      <div className="w-full max-w-md space-y-5 rounded-lg border bg-card p-6 shadow-sm">
        <div className="space-y-1">
          <h1 className="text-lg font-semibold">Synchronisation initiale</h1>
          <p className="text-sm leading-6 text-muted-foreground">
            Téléchargement des données en local pour que vous puissiez travailler hors-ligne. Cette étape ne se produit qu’à la première connexion.
          </p>
        </div>
        <div className="space-y-2">
          <div className="h-1.5 w-full overflow-hidden rounded-full bg-muted">
            <div
              className="h-full rounded-full bg-primary transition-all duration-300"
              style={{ width: `${pct}%` }}
            />
          </div>
          <p className="text-xs text-muted-foreground">{detail}</p>
        </div>
      </div>
    </div>
  );
}
